import { Card, CardContent } from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { useTranslation } from '@/hooks/useTranslation'

export const ReactSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="react-vite" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.react.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.react.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							index.html
						</code>{' '}
						{t('docs.react.instruction.suffix')}
					</p>
					<CodeBlock
						language="html"
						copyLabel={t('docs.react.copyLabel')}
						copyMessage={t('docs.react.copyMessage')}
						code={`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>My React App</title>
  </head>
  <body>
    <div id="root"></div>
    
    <!-- Feedbask Widget -->
    <script
      defer
      src="https://cdn.feedbask.com/widget.js"
      data-client-key="YOUR_WIDGET_ID"
      data-language="en"
      id="feedbask-widget-script"
    ></script>
    
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>`}
					/>
				</CardContent>
			</Card>
		</section>
	)
}